import React, { useEffect, useState } from "react";
import classnames from "classnames";
import _ from "lodash";
import moment from "moment";
import DateTimePicker from "../../../components/DateTimePicker";
import TimePicker from "../../../components/TimePicker";
import RadioItem from "../../../components/RadioItem";

const FeedPosting = ({ selectedDate, onChangeTime, isVisible }) => {
  const [scheduling, setScheduling] = useState({});
  const [toMembers, setToMembers] = useState(true);
  const [toReferrals, setToReferrals] = useState(true);
  const [textComments, setTextComments] = useState(true);
  const [mediaComments, setMediaComments] = useState(true);

  useEffect(() => {
    onChangeTime(scheduling);
  }, [scheduling]);
  const handleSchedule = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.scheduledDate = value;
    setScheduling(newScheduling);
  };
  const handlePostNowChanged = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.postNow = value;
    setScheduling(newScheduling);
  };
  const handleChangeTime = (obj) => {
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(selectedDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    const newScheduling = _.cloneDeep(scheduling);
    if (newMoment.isBefore(moment())) {
      newScheduling.postNow = true;
    } else newScheduling.postNow = false;
    newScheduling.scheduledDate = newMoment;
    setScheduling(newScheduling);
  };
  const handleChangeMembersAccess = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.toMembers = value;
    setScheduling(newScheduling);
  };
  const handleChangeReferralsAccess = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.toReferrals = value;
    setScheduling(newScheduling);
  };
  const handleTextComments = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.textComments = value;
    setScheduling(newScheduling);
  };
  const handleMediaComments = (value) => {
    const newScheduling = _.cloneDeep(scheduling);
    newScheduling.mediaComments = value;
    setScheduling(newScheduling);
  };

  return (
    <div className={`feed-schedule-container ${!isVisible ? "d-none" : ""}`}>
      <p className="feed-schedule-title">
        {!selectedDate && (
          <React.Fragment>
            <b>Post now</b> or{" "}
          </React.Fragment>
        )}
        <b>Schedule</b>
      </p>
      {!selectedDate && (
        <div className="feed-schdule-now-container">
          <div
            className={classnames("check-box", {
              checked: scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(true)}
            style={{
              marginLeft: "20px",
            }}
          ></div>
          <div
            className={classnames("check-box", {
              checked: !scheduling.postNow,
            })}
            onClick={() => handlePostNowChanged(false)}
            style={{
              marginLeft: "80px",
            }}
          ></div>
        </div>
      )}
      {!scheduling.postNow && !selectedDate && (
        <DateTimePicker onTimeChange={handleSchedule} />
      )}
      {selectedDate && (
        <React.Fragment>
          <p className="feed-schedule-time">{selectedDate.format("LLL")}</p>
          <TimePicker onChange={handleChangeTime} />
        </React.Fragment>
      )}
      <div className="user-access-categories">
        <p>Post to user access categories</p>
        <RadioItem
          menuName="Members"
          checked={toMembers}
          onYes={() => {
            setToMembers(true);
            handleChangeMembersAccess(true);
          }}
          onNo={() => {
            setToMembers(false);
            handleChangeMembersAccess(false);
          }}
        />
        <RadioItem
          menuName="Prospect"
          checked={toReferrals}
          onYes={() => {
            setToReferrals(true);
            handleChangeReferralsAccess(true);
          }}
          onNo={() => {
            setToReferrals(false);
            handleChangeReferralsAccess(false);
          }}
        />
        <RadioItem
          menuName="Text comments"
          checked={textComments}
          onYes={() => {
            setTextComments(true);
            handleTextComments(true);
          }}
          onNo={() => {
            setTextComments(false);
            setMediaComments(false);
            handleTextComments(false);
            handleMediaComments(false);
          }}
        />
        <RadioItem
          menuName="Media comments"
          checked={mediaComments}
          onYes={() => {
            if (textComments) {
              setMediaComments(true);
              handleMediaComments(true);
            }
          }}
          onNo={() => {
            setMediaComments(false);
            handleMediaComments(false);
          }}
        />
      </div>
    </div>
  );
};
export default FeedPosting;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/FeedPosting.js